import { CtaSidebarDownloadProps } from '@/components/_blog-updates/CtaSidebarDownload';
import { CraftCtaSidebarDownloadData } from './CraftCtaSidebarDownload.types';

export const mapBlockToCtaSidebarDownloadProps = (
  block: CraftCtaSidebarDownloadData,
): CtaSidebarDownloadProps => {
  const previewImage = block.ctaDownloadImage?.[0];
  const asset = block.ctaDownloadAsset?.[0];

  return {
    image: previewImage?.url ?? '',
    ctaText: block.ctaDownloadText ?? '',
    ctaHref: asset?.url ?? '',
  };
};
